import { render } from "./Login.vue?vue&type=template&id=061f16b2&lang=pug"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"
script.render = render

export default script